<div class="app-my-moon-history" [ngClass]="httpService.theme">
    <div class="row mb-1">
        <div class="col-md-9"></div>
        <div class="col-md-3">
            <cf-dropdown [theme]="httpService.theme" [options]=" reward_type_options"
                (change)="changeRewardType($event)" label="Filter" [showLogo]="false" [selected]="reward_type"
                [showDescription]="true">
            </cf-dropdown>
        </div>
    </div>

    <div class="middle-section" [ngClass]="{'loader-container': loading_stats}">
        <cf-loader *ngIf="loading_stats"></cf-loader>
        <div class="member-stats" *ngIf="!loading_stats">
            <div>
                <cf-card [theme]="httpService.theme" [stat]="stats.all" heading="All time" type="compact"></cf-card>
            </div>
            <div>
                <cf-card [theme]="httpService.theme" [stat]="stats.last_7d" heading="Last 7 days"
                    type="compact"></cf-card>
            </div>
            <div>
                <cf-card [theme]="httpService.theme" [stat]="stats.last_30d" heading="Last 30 days"
                    type="compact"></cf-card>
            </div>
            <div>
                <cf-card [theme]="httpService.theme" [stat]="stats.last_60d" heading="Last 60 days"
                    type="compact"></cf-card>
            </div>
        </div>
    </div>

    <div *ngIf="!loading && moons.length > 0">
        <mat-expansion-panel (afterExpand)="afterExpand(item.credit_id)" [expanded]="opened_panel === item.credit_id"
            (afterCollapse)="afterCollapse(item.credit_id)" [ngClass]="getStatusClasses()" *ngFor="let item of moons;">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <span>
                        {{ item.created | date : "mediumDate" }}
                    </span>
                    <span>
                        {{ item.moons | number:'0.0-0' }} moons
                    </span>
                    <span>
                        {{ item.type }}
                    </span>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <table>
                <tbody>
                    <tr>
                        <td class="txn-heading">Date</td>
                        <td>
                            {{ item.created | date : "medium" }}
                        </td>
                    </tr>
                    <tr>
                        <td class="txn-heading">Moons</td>
                        <td>
                            {{ item.moons | number:'0.0-0' }} moons
                        </td>
                    </tr>
                    <tr>
                        <td class="txn-heading">Type</td>
                        <td>
                            {{ item.type }}
                        </td>
                    </tr>
                    <tr>
                        <td class="txn-heading">Referral</td>
                        <td>
                            {{ item.referrals ? "Yes" : "No" }}
                        </td>
                    </tr>
                    <tr>
                        <td class="txn-heading">Credit Id</td>
                        <td>
                            {{ item.credit_id }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </mat-expansion-panel>
        <cf-paginator *ngIf="total_count > 0" [page]="page + 1" [count]="total_count" [limit]="limit"
            (changed)="pageChanged($event)"></cf-paginator>
    </div>

    <div class="no-data" *ngIf="
                total_count === 0 &&
                !loading
            ">
        No records found
    </div>

    <div class="loader" *ngIf="loading">
        <cf-loader></cf-loader>
    </div>
</div>